/**
 * 创建人：但志强
 * 时间：2019-6-11
 * 描述：绑定回车功能
 * 更新记录: 
 */
import { Directive, HostListener, ElementRef, Input } from '@angular/core';


/**
 * 绑定回车事件 触发点击
 */
@Directive({
  selector: '[SwEnterButton]'
})
export class SwEnterButtonDirective {

  /**
   * @ignore
   */
  constructor(private el: ElementRef) { }

  // @Input('SwEnterButton') eventName:string

  /**
   * @ignore
   */
  @HostListener('document:keydown', ['$event']) onkeydown(event) {
    //鉴定全屏键盘事件 如果是回车触发
    if(event.which==13){  
      if(!(event.srcElement.name =="textarea")){
        if(document.getElementsByTagName('body')[0].contains(this.el.nativeElement)){
          this.el.nativeElement.click();
        }
      }
    }
  }
}
